export default class GroupModel {
  id!: number;

  descricao!: string;
}
